import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import Fab from '@material-ui/core/Fab';

const styles = theme => ({
  // for Ko Min Min's playicon design
  // playBtn: {
  //   background: 'rgba(255, 255, 255, 0.4)', 
  //   position: 'absolute', 
  //   top: '40%',
  //   width: 35,
  //   height: 35,
  //   '&::before': {
  //       content: "''",
  //       position: 'absolute',
  //       width: 43,
  //       height: 43,
  //       borderRadius: '50%',
  //       border: '1px solid #fff'
  //   }
  // }
  playBtn: {
    background: 'rgba(0, 0, 0, 0.4)', 
    border: '1px solid #fff',
    verticalAlign: 'middle',
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: 'auto',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.7)'
    },
    '&:focus': {
      background: 'rgba(0, 0, 0, 0.9)'
    }
  },

});

function PlayIconButton(props) {
  const { classes } = props;

  return (
        <span style={{justifyContent: 'center', display: 'flex'}}>
            {/* <Fab classes={{ root: classes.playBtn }}> */}
            <Fab className={classes.playBtn} style={{ width: props.bigBtn ? props.bigBtn : 35, height: props.bigBtn ? props.bigBtn : 35 }}>
              <Icon style={{color: '#fff'}}>play_arrow</Icon>
            </Fab>
        </span>
  );
}

PlayIconButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PlayIconButton);
